import { Autorizacao, Orcamento } from '@/types/core'
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import { Auth } from '@finx/web-repository/src/services/Oidc'
// eslint-disable-next-line
import {
  AgendamentoSolicitacaoItem,
  AgendamentoCirurgia,
  Lembrete,
  Medico,
  StatusAvaliacaoPreAnestesia,
  NovaDataSolicitada,
  Convenio,
  Situacao,
  TipoDocumentoUpload,
  StatusCirurgiaEnum,
  Hospital,
  CentroCirurgico,
  // eslint-disable-next-line
} from '@/types/_'
import Apis from '@/Apis/_'
import _ from 'lodash'
import { getUser } from '@/utils/common'
import ProtocoloApi from '@/Apis/Agendamento/Services/ProtocoloApi'
import { IProtocolo, IProtocolPendency } from '../../../types/interfaces/protocolo/protocolo.interface'

@Module({ namespaced: true, name: 'BackofficeRegulacaoStore' })
export default class BackofficeRegulacaoStore extends VuexModule {
  private orcamento: Orcamento.IOrcamento = new Orcamento.Orcamento()
  private novaDataSolicitadaDefault: NovaDataSolicitada = {
    dataAgendamento: null,
    dataAgendamentoVirtual: false,
    solicitacaoId: '',
    opcaoDataPrevisto1: '',
    opcaoDataPrevisto2: '',
    opcaoDataPrevisto3: '',
    opcao: 0,
    data: '',
    hora: '',
    alterarData: false,
    numeroAgendamento: '',
  }

  private lembreteDefault: Lembrete = {
    dataLembrete: null,
  }

  public statusProtocolo: string[] = ['ProtocoloNaoAderente']

  public lembrete: Lembrete = { ...this.lembreteDefault }
  public lembreteStatusFiltro: string = ''
  public deFiltro: Date | string | null = null
  public ateFiltro: Date | string | null = null
  public hospitais: Hospital[] = []
  public hospitaisFiltro: string[] = []
  public convenios: Convenio[] = []
  public medicoId: string = ''
  public paciente: string = ''
  public medicosCadastrados: any = []
  public convenioFiltro: string[] = []
  public preAnestesiaFiltro: string = ''
  public opmeFiltro: string = ''
  public novaDataSolicitadaFiltro: boolean = false
  public dataPrevistaFiltro: boolean = false
  public dataVirtualFiltro: boolean = false
  public origemFiltro: string | null = null
  public statusPrecificacaoOperadoraFiltro: string | null = null
  public numeroAgendamento: string = ''
  public ordenadoPorId: string = 'DataUltimaInteracaoAsc'
  public etapaQuery: string = ''
  public statusAvaliacaoPreAnestesiaQuery: string[] = []
  public data: string[] = []
  public medicos: Medico[] = []
  public situacoes: string[] = ['AguardandoOrcamento']
  public situacoesCounter: Situacao[] = []
  public cirurgiaRealizada: boolean | null = false
  public ordenadoPor: any = [
    { id: 'DataUltimaInteracaoAsc', value: 'Tempo de ação mais antigo' },
    { id: 'DataUltimaInteracaoDesc', value: 'Tempo de ação mais recente' },
  ]

  public preAnestesiaStatus: any[] = [
    { nome: 'Pendente', status: 'Pendente' },
    { nome: 'Apto', status: 'Apto' },
    { nome: 'Apto com atenção', status: 'AptoComAtencao' },
    { nome: 'Não apto', status: 'NaoApto' },
  ]

  public statusAvaliacaoPreAnestesia: StatusAvaliacaoPreAnestesia[] = []


  public visualizarTriagem: boolean = false
  public novaDataSolicitada: NovaDataSolicitada = { ...this.novaDataSolicitadaDefault }
  public agendamentosCirurgia: AgendamentoCirurgia[] = []

  public filterOn: boolean = false
  public filterDrawer: boolean = false
  public solicitacoes: AgendamentoSolicitacaoItem[] = []

  private paginaDefault: number = 1
  private qtdPorPaginaDefault: number = 25
  public surgerySolicitationProtocols: IProtocolo[] = []

  public pagina: number = this.paginaDefault
  public qtdPorPagina: number = this.qtdPorPaginaDefault
  public totalSolicitacoes: number = 0
  public anexo: any[] = []
  public reservaUti: string[] = []
  public statusRoboAutorizacao: string[] = []
  public mapaCirurgicoStatus: string[] = []
  public tiposAcomodacao: string[] = []
  public sexo: string = ''
  public centrosCirurgico: CentroCirurgico[] = []
  public centroCirurgico: string = ''

  @Mutation
  setSurgerySolicitationProtocols(protocols: IProtocolo[]) {
    this.surgerySolicitationProtocols = protocols
  }

  @Mutation
  setCentroCirurgico(value: any) {
    this.centroCirurgico = value
  }

  @Mutation
  setCentrosCirurgico(value: CentroCirurgico[]) {
    this.centrosCirurgico = value
  }

  @Mutation
  clearCentroCirurgico() {
    this.centroCirurgico = ''
  }

  @Mutation
  removeReservaUti(value: string) {
    const index = this.reservaUti.indexOf(value)
    if (index >= 0) this.reservaUti.splice(index, 1)
  }

  @Mutation
  removeStatusRoboAutorizacao(value: string) {
    const index = this.statusRoboAutorizacao.indexOf(value)
    if (index >= 0) this.statusRoboAutorizacao.splice(index, 1)
  }

  @Mutation
  removeMapaCirurgicoStatus(value: any) {
    const index = this.mapaCirurgicoStatus.indexOf(value)
    if (index >= 0) this.mapaCirurgicoStatus.splice(index, 1)
  }

  @Mutation
  removeTipoAcomodacao(value: string) {
    const index = this.tiposAcomodacao.indexOf(value)
    if (index >= 0) this.tiposAcomodacao.splice(index, 1)
  }

  @Mutation
  setSexo(value: string) {
    this.sexo = value
  }

  @Mutation
  setReservaUti(value: string[]) {
    this.reservaUti = value
  }

  @Mutation
  setStatusRoboAutorizacao(value: string[]) {
    this.statusRoboAutorizacao = value
  }

  @Mutation
  setmapaCirurgicoStatus(value: string[]) {
    this.mapaCirurgicoStatus = value
  }

  @Mutation
  setTiposAcomodacao(value: string[]) {
    this.tiposAcomodacao = value
  }

  @Mutation
  setFilterDrawer(value: boolean) {
    this.filterDrawer = value
  }

  @Mutation
  setAgendamentos(solicitacoes: AgendamentoSolicitacaoItem[]) {
    const slct = solicitacoes.map((e: any) => {
      if (!e.lembreteStatus) e.lembreteStatus = ''
      if (!e.dataAgendamento) e.dataAgendamento = ''

      if (e.statusCirurgia) {
        e.cirurgiaRealizada = e.statusCirurgia === StatusCirurgiaEnum.Realizada
      }

      return e
    })
    this.solicitacoes = slct
  }

  @Mutation
  setCirurgiaRealizada(value: boolean | null) {
    this.cirurgiaRealizada = value
  }

  @Mutation
  setOrderBy(orderBy: string) {
    this.ordenadoPorId = orderBy
  }

  @Mutation
  setPaciente(paciente: string) {
    this.paciente = paciente
  }

  @Mutation
  setNovaDataSolicitadaFiltro(value: boolean) {
    this.novaDataSolicitadaFiltro = value
  }

  @Mutation
  setDataPrevistaFiltro(value: boolean) {
    this.dataPrevistaFiltro = value
  }

  @Mutation
  setConvenioFiltro(value: string[]) {
    this.convenioFiltro = value
  }

  @Mutation
  setPreAnestesiaFiltro(value: string) {
    this.preAnestesiaFiltro = value
  }

  @Mutation
  setStatusPrecificacaoOperadora(value: string | null) {
    this.statusPrecificacaoOperadoraFiltro = value
  }

  @Mutation
  setOpmeFiltro(value: string) {
    this.opmeFiltro = value
  }

  @Mutation
  setDataVirtualFiltro(value: boolean) {
    this.dataVirtualFiltro = value
  }

  @Mutation
  setOrigemFiltro(value: string | null) {
    this.origemFiltro = value
  }

  @Mutation
  setDataAgendamentoVirtual(value: boolean) {
    this.dataVirtualFiltro = value
  }

  @Mutation
  setSalaVirtual(value: boolean) {
    this.novaDataSolicitada.dataAgendamentoVirtual = value
  }

  @Mutation
  setMedicos(medicos: Medico[]) {
    this.medicos = medicos
  }

  @Mutation
  setMedicoAssistentes(medicos: any[]) {
    this.medicosCadastrados = medicos
  }

  @Mutation
  setMedicoId(value: string) {
    this.medicoId = value
  }

  @Mutation
  setNumeroAgendamento(value: string) {
    this.numeroAgendamento = value
  }

  @Mutation
  setNumeroReserva(value: string) {
    this.novaDataSolicitada.numeroAgendamento = value
  }

  @Mutation
  setOrdenadoPorId(value: string) {
    this.ordenadoPorId = value
  }

  @Mutation
  setStatusAvaliacaoPreAnestesia(value: StatusAvaliacaoPreAnestesia[]) {
    this.statusAvaliacaoPreAnestesia = value
  }

  @Mutation
  removeConvenioFiltro(value: string) {
    const index = this.convenioFiltro.indexOf(value)
    if (index >= 0) this.convenioFiltro.splice(index, 1)
  }

  @Mutation
  setData(value: string) {
    if (this.data.includes(value)) return
    this.data.push(value)
  }

  @Mutation
  setSituacoes(value: string) {
    if (this.situacoes.includes(value)) {
      this.situacoes.splice(this.situacoes.indexOf(value), 1)
    } else {
      this.situacoes.push(value)
    }
  }

  @Mutation
  clearFidelizationStatuses() {
    this.statusProtocolo = []
  }

  @Mutation
  addFidelizationStatus(status: string) {
    if (this.statusProtocolo.includes(status)) {
      this.statusProtocolo.splice(this.statusProtocolo.indexOf(status), 1)
    } else {
      this.statusProtocolo.push(status)
    }
  }

  @Mutation
  resetSituacoes() {
    this.situacoes = ['AguardandoOrcamento']
  }

  @Mutation
  fillAllSituacoes() {
    this.situacoes = [
      'AguardandoOrcamento',
      'AguardandoAprovacaoOrcamento',
      'OrcamentoAprovado',
      'OrcamentoRecusado',
    ]
  }

  @Mutation
  clearAnexo() {
    this.anexo = []
  }

  @Mutation
  setSituacoesCounter(value: Situacao[]) {
    this.situacoesCounter = value
  }

  @Mutation
  removeData(value: string) {
    const index = this.data.indexOf(value)
    if (index >= 0) this.data.splice(index, 1)
  }

  @Mutation
  clearAgendamentosCirurgia() {
    this.agendamentosCirurgia = []
  }

  @Mutation
  setFilterOn(value: boolean) {
    this.filterOn = value
  }

  @Mutation
  setPagina(value: number) {
    this.pagina = value
  }

  @Mutation
  setQtdPorPagina(value: number) {
    this.qtdPorPagina = value
  }

  @Mutation
  setTotalSolicitacoes(value: number) {
    this.totalSolicitacoes = value
  }

  @Mutation
  clearPagePagination() {
    this.pagina = this.paginaDefault
    this.qtdPorPagina = this.qtdPorPaginaDefault
  }

  @Mutation
  clearSurgerySolicitations() {
    this.solicitacoes = []
  }

  @Mutation
  deleteSolicitacao(solicitacaoId: string) {
    const index = this.solicitacoes.findIndex(c => c.id === solicitacaoId)
    if (index >= 0) {
      this.solicitacoes.splice(index, 1)
    }
  }

  @Mutation
  setLembreteStatus(params: any) {
    const solicitacao = this.solicitacoes.find((e: any) => e.id === params.solicitacaoId)
    const solicitacaoIndex = this.solicitacoes.findIndex((e: any) => e.id === params.solicitacaoId)
    // @ts-ignore
    solicitacao.lembreteStatus = params.concluido ? '' : 'Normal'
    // @ts-ignore
    this.solicitacoes[solicitacaoIndex] = solicitacao
  }

  @Mutation
  setLembreteStatusFiltro(value: string) {
    this.lembreteStatusFiltro = value
  }

  @Mutation
  setEtapa(etapa: string) {
    this.etapaQuery = etapa
  }

  @Mutation
  setAnexo(anexo: any) {
    if (!this.anexo) {
      this.anexo = []
    }
    this.anexo.push(anexo)
  }

  @Mutation
  setAnexos(anexo: any[]) {
    this.anexo = anexo
  }

  @Action
  async blockFidelizationSurgerySolicitation(surgerySolicitationId: string): Promise<any> {
    const APIResponse = await ProtocoloApi.blockFidelizationSurgerySolicitation(surgerySolicitationId)
    return APIResponse
  }

  @Action
  async unblockFidelizationSurgerySolicitation(surgerySolicitationId: string): Promise<any> {
    const APIResponse = await ProtocoloApi.unblockFidelizationSurgerySolicitation(surgerySolicitationId)
    return APIResponse
  }

  @Action
  async getSurgerySolicitationProtocol({ hospitalId, protocolId }): Promise<IProtocolo | { kitsDeOpme: any, tecnicasDeCirurgia: any }> {
    if (hospitalId && protocolId) {
      const surgeryProtocolAPIResponse = await ProtocoloApi.getProtocoloById({ hospitalId, protocoloId: protocolId })
      return surgeryProtocolAPIResponse.data || { kitsDeOpme: [], tecnicasDeCirurgia: [] }
    }

    return { kitsDeOpme: [], tecnicasDeCirurgia: [] }
  }

  @Action
  async openProtocolPendency({
    surgerySolicitationId,
    protocolId,
    surgeryTechniqueId,
    reasonSelectedKit,
    surgeryMaterialKitId,
  }: {
    surgerySolicitationId: string,
    protocolId?: string,
    reasonSelectedKit: string,
    surgeryMaterialKitId?: string,
    surgeryTechniqueId?: string,
  }): Promise<any> {
    const parsedBody: IProtocolPendency = {
      observacaoDaPendenciaDeProtocolo: reasonSelectedKit,
    }

    if (protocolId) {
      parsedBody.protocoloId = protocolId
    }

    if (surgeryMaterialKitId) {
      parsedBody.kitId = surgeryMaterialKitId
    }

    if (surgeryTechniqueId) {
      parsedBody.tecnicaId = surgeryTechniqueId
    }

    const APIResponse = await ProtocoloApi.openProtocolPendency(surgerySolicitationId, parsedBody)
    return APIResponse
  }

  @Action
  async sendToFidelization({
    surgerySolicitationId,
    reason,
  }): Promise<any> {
    const APIResponse = await ProtocoloApi.sendToFidelization(surgerySolicitationId, reason)
    return APIResponse
  }

  @Action
  async regulacaoFazAnalise({
    surgerySolicitationId,
    reason,
    statusFidelizacao,
  }): Promise<any> {
    const APIResponse = await ProtocoloApi.regulacaoFazAnalise(surgerySolicitationId, statusFidelizacao, reason)
    return APIResponse
  }

  @Action({ commit: 'setSurgerySolicitationProtocols' })
  async getAllSurgerySolicitationProtocols(surgerySolicitation) {
    const { hospitalId, medicoSolicitanteId: doctorId, procedimento: procedure, paciente: patient } = surgerySolicitation
    const { convenioId: healthInsuranceId, planoId: planId } = patient
    const { codigo: procedureCode } = procedure

    if (
      hospitalId && doctorId
      && procedure && procedureCode
      && patient && healthInsuranceId
    ) {
      const surgeryProtocolsAPIResponse = await ProtocoloApi.getProtocolosByCirurgia({
        hospitalId, medicoId: doctorId, codigoDoProcedimentoPrincipal: procedureCode, convenioId: healthInsuranceId, planoId: planId,
      })

      return surgeryProtocolsAPIResponse.data || []
    }

    return []
  }

  @Action({ commit: 'setConvenios' })
  async getAllConvenios() {
    const request = await this.orcamento.getAllConveniosByUsuarioHospitalLogado()
    if (request.success) return request.data
    return []
  }

  @Action({ commit: 'setMedicos' })
  async loadAMedicos() {
    const user = await Auth.getUser()
    const usuarioId = user.profile.sub
    const request = await this.orcamento.getAllMedicoByUsuarioId(usuarioId)
    if (request.success) return request.data
    return []
  }

  @Action
  async deleteLaudo(params: any) {
    const request = await this.orcamento.deleteLaudo(params.hospitalId, params.id)

    return request
  }

  @Action
  async uploadAnexos(params: any) {
    const response = await this.orcamento.upload(params.form, TipoDocumentoUpload.OrcamentoDeCirurgiaParticular, params.header, params.solicitacaoId)
    return response
  }

  @Action
  async getAllLaudos(solicitacaoId: string) {
    const response = await this.orcamento.getAllLaudos(solicitacaoId, TipoDocumentoUpload.OrcamentoDeCirurgiaParticular)
    if (response.success) {
      this.context.commit('setAnexos', response.data)
    }
    return response
  }

  @Action
  async backofficeOrcamentoEnviaOrcamento(params: any) {
    const response = await this.orcamento.backofficeOrcamentoEnviaOrcamento(params)
    return response
  }

  @Action({ commit: 'setHospitais' })
  async getAllHospitais() {
    const request = await this.orcamento.getHospitalCurrentUser()
    if (request.success) return request.data
    return []
  }

  @Action
  async getCentroCirurgicoByHospitalId(params: any) {
    const { hospitalIds } = params
    if (hospitalIds && hospitalIds.length <= 0) {
      this.context.commit('setCentrosCirurgico', [])
      this.context.commit('clearCentroCirurgico')
      return null
    }

    const request = await this.orcamento.getCentroCirurgico(params)
    if (request.success) {
      request.data.map((c) => {
        const temp = c
        temp.nome = `${c.hospital.nome} - ${c.nome}`
        return temp
      })

      this.context.commit('setCentrosCirurgico', request.data)
    }
    return request
  }

  @Action
  init() {
    this.context.dispatch('getAllHospitais')
    this.context.dispatch('getAllConvenios')
    this.context.dispatch('loadAMedicos')
  }
}
